import styled from 'styled-components';
import { Box, media } from '@simplywallst/ui-core';
import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';

export const SnowflakeBlur = styled('div')<{ backgroundColor: string }>`
  width: 80px;
  height: 80px;
  position: absolute;
  opacity: 0.2;
  filter: blur(38px);
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const getBackgroundImageUrl = (imgUrl: string) =>
  getCloudflareImageUrl({
    src: getStaticUrl(imgUrl),
    quality: 100,
  });

export const Container = styled(Box)`
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 8px;
  min-width: 288px;
  min-height: 240px;
  background-image: url(${getBackgroundImageUrl(
    'portfolio/portfolio-card/limited-portfolio-bg-368px-2x.png'
  )});
  ${media.lgDown`
  background-image: url(${getBackgroundImageUrl(
    'portfolio/portfolio-card/limited-portfolio-bg-510px-2x.png'
  )});
  `}
  ${media.mdDown`
  background-image: url(${getBackgroundImageUrl(
    'portfolio/portfolio-card/limited-portfolio-bg-410px-2x.png'
  )});
  `}
  ${media.smDown`
  background-image: url(${getBackgroundImageUrl(
    'portfolio/portfolio-card/limited-portfolio-bg-640px-2x.png'
  )});
  `}
  ${media.xsDown`
  background-image: url(${getBackgroundImageUrl(
    'portfolio/portfolio-card/limited-portfolio-bg-410px-2x.png'
  )});
  `}
  @media (max-width: 375px) {
    background-image: url(${getBackgroundImageUrl(
      'portfolio/portfolio-card/limited-portfolio-bg-288px-2x.png'
    )});
  }
`;
